<template>
  <div class="app-main-inner app-main-page" style="height:auto">
    <div class="app-main-inner-row">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzyModelSearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid" style="min-height:300px;">
      <cargo-ag-grid
        no="grid"
        :grid-options="gridOptions"
        :side-bar="sideBarDefs"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
        @gridReady="onGridReady"
      />
    </div>
    <div class="app-main-inner-row row-pagination" style="padding-right:0px;">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
  </div>
</template>

<script>
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getAllAirplaneModelTemplate } from '@/api/basicData/airplaneModel'

export default {
  name: 'BaseAirplaneModel',
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        isRowSelectable: function(row) {
          return row.data && !row.data.added
        },
        context: {
          componentParent: this
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        {
          headerName: '',
          pinned: 'left',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.serialNumber'),
          field: 'serialNumber',
          width: 100
        },
        {
          headerName: this.$t('Pricing.Aircraft'),
          field: 'model',
          width: 100
        },
        {
          headerName: this.$t('Pricing.AircraftFullName'),
          field: 'fullName',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.TotalCubage'),
          field: 'totalVolume',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.TotalWeight2') + '(T)',
          field: 'totalWeight',
          width: 100
        },
        {
          headerName: this.$t('common.tips.isAdded'),
          field: 'added',
          cellRenderer: params => {
            const iconName = !params.data.added ? 'grid-icon-enabled' : 'grid-icon-disabled'
            const color = params.data.added ? '#67c23a' : '#e6a23c'
            return `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
              </svg>`
          },
          suppressMenu: true
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  created() {
    const self = this
    document.resetBaseAirplaneModel = function() {
      self.toQuery()
    }
    document.getSelectedBaseAirplaneModelRows = function() {
      return self.gridApi.getSelectedRows()
    }
  },
  beforeDestroy() {
    document.resetBaseAirplaneModel = null
    document.getSelectedBaseAirplaneModelRows = null
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
    },
    toQuery() {
      const self = this
      getAllAirplaneModelTemplate(self.filter).then(res => {
        for (const item of res.data.list) {
          item.isAddedStr = item.isAdded ? this.$t('common.tips.yes') : this.$t('common.tips.no')
        }
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
        self.onGridDateRendered()
      })
    },
    onGridDateRendered() {
      const self = this
      const columnApi = self.gridApi.columnController.columnApi
      const columnIds = []
      self.gridApi.columnController.gridColumns.forEach(p => {
        columnIds.push(p.colId)
      })
      setTimeout(() => {
        columnApi.autoSizeColumns(columnIds)
      })
    }
  }
}
</script>

<style>
</style>
